let enqueueSnackbarRef = null;
const pendingSnackbarEvents = [];

export function registerSnackbar(enqueueSnackbar) {
  enqueueSnackbarRef = enqueueSnackbar;

  while (pendingSnackbarEvents.length) {
    const { message, options } = pendingSnackbarEvents.shift();
    enqueueSnackbarRef(message, options);
  }
}

export function clearSnackbar() {
  enqueueSnackbarRef = null;
}

export function showSnackbar(message, options = {}) {
  if (!enqueueSnackbarRef) {
    pendingSnackbarEvents.push({ message, options });
    return;
  }

  if (!message) return;

  enqueueSnackbarRef(message, options);
}

export function showError(message) {
  showSnackbar(message, { variant: 'error' });
}
